import { deserializeKeywords } from '~/modules/retailMedia/helpers/keywords'

import {
  mapAgeRestrictedSetting,
  mapToCampaignProducts,
  handleSubpublishers
} from '../../../helpers'

export const DTOCreateProductCampaign = (
  data: DTOCreateProductCampaignPayload & { lengthCentsCurrency: number }
) => {
  /**
   * Handle products linkded to campaign
   */
  const { lengthCentsCurrency } = data

  const products = mapToCampaignProducts(data?.products || [])

  /**
   * Handle campaign settings
   */

  const cpcRaw = data.budget.cpc.numAsString
  const cpc = lengthCentsCurrency ? Number(cpcRaw) / 100 : Number(cpcRaw)

  const dailyBudgetRaw = data.budget.daily.numAsString
  const dailyBudget = lengthCentsCurrency
    ? Number(dailyBudgetRaw) / 100
    : Number(dailyBudgetRaw)

  const settings: DTOCreateProductCampaignSettings = {
    daily_budget: dailyBudget,
    cpc,
    ...mapAgeRestrictedSetting(data?.settings)
  }

  const additionalKeywords = deserializeKeywords(
    data?.settings?.additional_keywords
  )
  const negativeKeywords = deserializeKeywords(
    data?.settings?.negative_keywords
  )

  if (additionalKeywords) {
    settings['additional_keywords'] = additionalKeywords
  }

  if (negativeKeywords) {
    settings['negative_keywords'] = negativeKeywords
  }

  if (data?.placements?.placementsCheck === 'selected') {
    const placements = data?.placements?.placements_ids
    const selectedPlacements = Object.values(placements).filter(
      values => values.checked
    )

    settings.placements = selectedPlacements.map(({ value: id }) => ({ id }))
  }

  if (data?.settings?.budget_type) {
    settings.budget_type = data.settings.budget_type
  }

  let body: DTOCreateProductCampaignResponse = {
    publisher_id: data?.publisher_id,

    audience_id: data?.audience_id,

    name: data.name,
    description: data?.description,

    type: 'on_site',
    ad_type: 'product',

    start_at: data.start_date,
    end_at: data?.end_date || null,

    products,

    settings
  }

  const totalBudgetRaw = data.budget?.total?.numAsString

  if (totalBudgetRaw) {
    const total_budget = lengthCentsCurrency
      ? Number(totalBudgetRaw) / 100
      : Number(totalBudgetRaw)

    body.total_budget = total_budget
  }

  body = handleSubpublishers<DTOCreateProductCampaignResponse>({ body, data })

  return body
}
